// 9fbef606107a605d69c0edbcd8029e5d
/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';

const WrappedComponent = styled.div`
  display: ${(props) => (!props.isGiftCard ? 'inline-block' : 'none')};
  height: ${(props) => (props.height ? props.height : '100%')};
  width: ${(props) => (props.width ? props.width : '100%')};
  min-height: ${(props) => (props.height ? props.height : '15px')};
  ${(props) => (props.borderRadius ? `border-radius: ${props.borderRadius};` : '')}
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '#d8d8d8')};
  overflow: hidden;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-image: linear-gradient(
      90deg,
      rgb(134 131 131 / 10%),
      rgb(12 10 10 / 40%),
      rgb(151 150 150 / 10%)
    );
    animation: gradientAnimation 5s linear infinite;
    opacity: 0.7;
    transition: opacity 0.5s ease-in-out;
  }
  @keyframes gradientAnimation {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  &:hover:before {
    opacity: 1;
  }
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;

const SkeletonLine = (props) => <WrappedComponent {...props} />;

export default errorBoundary(SkeletonLine);
